import React from "react";
import {Col, Row} from 'react-bootstrap';
import './style.css';
import { useNavigate } from "react-router-dom";

const HorizontalMenu = ({menu=[], anew, lang})=> {
  let navigate = useNavigate();
  return (
    <>
    <Row>
      <Col xs={12} md={12}>
        <div className="card-group hmenu-group">
          {menu.map(item=>{
            return(
              <div className="card hmenu" key={item.key} >
                <div className="card-header" style={{ 
                  backgroundColor: item.backcolor,
                  color: item.color
                }}>
                  <span onClick={() => navigate( item.href )}>
                    {lang[item.lang]} ❯
                  </span>
                </div>
                <img 
                  alt={item.image}
                  crossOrigin="anonymous"
                  onClick={()=> navigate( item.href )} 
                  className="card-img-bottom" src={item.image} style={{ height:'200px' , objectFit: 'cover'}}/>
                  
              </div>
            )
          })}
        </div>
      </Col>
      </Row>
      <Row>
        <Col xs={12} md={12}>
          {anew && false &&<div className="card hmenu" onClick={() => navigate("news")}>
                <div className="card-header" style={{ 
                      backgroundColor:"red",
                      color:"white"
                    }}>
                      {lang.home_news}
                </div>
                <Col md={3} xs={12}>
                  <img 
                    className="card-img-top" 
                    src={anew.image}  onClick={() => navigate( anew.href )} 
                    alt={anew.image} 
                    style={{ width: '400px' }}/>
                </Col>
                <Col md={9} xs={12}>
                  <div className="card-body">
                    <b className="card-title" onClick={() => navigate( anew.href )} >{anew.title}</b>
                    <hr/>
                    <p className="card-text">{anew.short}</p>
                    <p className="card-text"><small className="text-muted">Actualizado el {anew.date}</small></p>
                  </div> 
                </Col>
            </div>
          }
        </Col>
      </Row>
    </>
  );
};

export default HorizontalMenu;